function hasLocalStorage() {
  try {
    return 'localStorage' in window && window['localStorage'] !== null;
  } catch (e) {
    return false;
  }
}

export const storage = hasLocalStorage() ? localStorage : sessionStorage;



// WEBPACK FOOTER //
// ./src/app/services/WebStorage/storage.js